import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from ".././../config/api";

export const fetchUserThreads = createAsyncThunk(
    "thread/fetchAllUserThreads",
    async (arg) => {                
        const response = await api.get(`thread/all/user?page=${arg.page || 1}&size=${arg.size || 10}`);        
        return response.data;
    }
);

export const fetchThreadById = createAsyncThunk(
    "thread/fetchThreadById",
    async (arg) => {
        const response = await api.get(`thread/${arg?.roomId}`);        
        return response.data;
    }
);

export const fetchUserThreadChats = createAsyncThunk(
    "thread/fetchUserThreadChats",
    async (arg) => {                
        const response = await api.get(`thread/${arg?.threadId}/chats/user?page=${arg.page || 1}&size=${arg.size || 10}`);  
        // console.log(response.data);
        return response.data;
    }
);

export const fetchUserThreadSystemNotifications = createAsyncThunk(
    "thread/fetchUserThreadSystemNotifications",
    async (arg) => {                
        const response = await api.get(`thread/${arg.threadId}/chats/notifications/user`);  
        // console.log(response.data.data);
        return response.data;
    }
);

export const fetchUserUnreadThreadCount = createAsyncThunk(
    "thread/fetchUserUnreadThreadCount",
    async () => {                
        const response = await api.get(`thread/unread-count`);  
        return response.data;
    }
);

export const fetchUnreadMessageThreads = createAsyncThunk(
    "thread/fetchUnreadMessageThreads",
    async (arg) => {
        const response = await api.get(`thread/unread-messages?page=${arg?.page || 1}&size=${arg?.size || 10}`);
        return response.data;
    }
);


// Notification/Message

export const fetchUserNotifications = createAsyncThunk(
    "thread/fetchUserMessages",
    async (arg) => {           
        console.log("api page:", arg.page);
             
        const response = await api.get(`thread/user/unread-latest-notifications?page=${arg?.page || 1}&size=${arg?.size ||10}`);  
        // console.log(response.data);
        return response.data;
    }
);


export const fetchUserMessageNotification = createAsyncThunk(
    "thread/fetchUserMessageNotification",
    async (arg) => {                
        const response = await api.get(`thread/user/unread-latest-messages?page=${arg?.page || 1}&size=${arg?.size ||10}`);  
        // console.log(response.data);
        return response.data;
    }
);
